import React from "react";
import { PickProgressData } from "../../OrderOverview/OrderOverview";

import styles from "./index.module.css";
import classNames from "classnames";

type Props = {
  value: PickProgressData["remainingQuantity"];
};

const RemainingQuantity = ({ value }: Props) => {
  const classes = classNames(styles["remaining-pick"], {
    [styles["remaining-pick--finished"]]: value === 0,
  });
  return (
    <div className={classes} title="antal som förekommer i ett senare stadie (WAMAS)">
      <p>+{value}</p>
    </div>
  );
};

export default RemainingQuantity;
